import { gql } from '@apollo/client';
const UPDATE_TENANT_SEASON = gql `
  mutation UpdateTenantSeason($seasonId: ID!, $name: String!) {
    updateSeason(seasonId: $seasonId, name: $name) {
      season {
        id
        name
        workingSeason
        canNameBeUpdated
        canBeRemoved
      }
    }
  }
`;
export default UPDATE_TENANT_SEASON;
